/* eslint-disable */
import { handleApiRequest } from 'Utils/handleApiRequest';

export const SET_CREW = 'SET_CREW';
export const SET_SELECTED_CREW = 'SET_SELECTED_CREW';
export const FETCHING_CREW = 'FETCHING_CREW';
export const DELETE_CREW = 'DELETE_CREW';
export const CREW_DELETED = 'CREW_DELETED';
export const CREW_UPDATED = 'CREW_UPDATED';
export const CREW_CREATED = 'CREW_CREATED';
export const CLEAR_CREW = 'CLEAR_CREW';

interface ActionTypes {
  SET_CREW: object;
  SET_SELECTED_CREW: object;
  FETCHING_CREW: boolean;
  DELETE_CREW: string;
  CREW_DELETED: boolean;
  CREW_UPDATED: boolean;
  CREW_CREATED: boolean;
  CLEAR_CREW: any;
}

interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export type nonAppCrewActionTypes = MessageAction;

export const listCrew =
  (companyId: number) =>
  async (dispatch: any, _getState = null, utils: any) => {
    setFetchingCrew(true);
    const response = await handleApiRequest(
      dispatch,
      utils.Api.get(`/companies/${companyId}/crew`, {
        params: { limit: 100 },
      })
    );
    if (response?.data) {
      dispatch({ type: SET_CREW, payload: response });
    } else {
      setFetchingCrew(false);
    }
  };

export const createCrew =
  (companyId: number, requestData: any) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(dispatch, utils.Api.post(`/companies/${companyId}/crew`, requestData));
    if (response?.data) {
      dispatch({ type: CREW_CREATED, payload: true });
    }
    return response;
  };

export const updateCrew =
  (companyId: number, crewId: number, requestData: any) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.patch(`/companies/${companyId}/crew/${crewId}`, requestData)
    );
    if (response?.data) {
      dispatch({ type: CREW_UPDATED, payload: true });
    }
    return response;
  };

export const deleteCrew =
  (companyId: number, crewId: number) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(dispatch, utils.Api.delete(`/companies/${companyId}/crew/${crewId}`));
    if (typeof response === 'string') {
      dispatch({ type: CREW_DELETED, payload: crewId.toString() });
    }
  };

export const setSelectedCrew = (crew: object) => (dispatch: any) => {
  dispatch({ type: SET_SELECTED_CREW, payload: crew });
};

export const setFetchingCrew = (value: boolean) => (dispatch: any) => {
  dispatch({ type: FETCHING_CREW, payload: value });
};

export const setCrewCreated = (value = false) => (dispatch: any) => {
  dispatch({ type: CREW_CREATED, payload: value });
};

export const setCrewUpdated = (value = false) => (dispatch: any) => {
  dispatch({ type: CREW_UPDATED, payload: value });
};

export const setCrewDeleted = (value = '') => (dispatch: any) => {
  dispatch({ type: CREW_DELETED, payload: value });
};

export const clearCrew = () => (dispatch: any) => {
  dispatch({ type: CLEAR_CREW });
};
